var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import * as React from 'react';
// Enhanced LoadingButton with better accessibility
const Button = styled((props) => {
    const { disabled, loading } = props, otherProps = __rest(props, ["disabled", "loading"]);
    // Add aria-busy attribute when loading to improve screen reader announcements
    const ariaAttributes = {
        'aria-busy': loading ? true : false,
        // Make sure disabled state is properly communicated to assistive technologies
        'aria-disabled': disabled ? true : false,
    };
    return _jsx(LoadingButton, Object.assign({}, otherProps, { size: 'small', disabled: disabled, loading: loading }, ariaAttributes));
})(({ theme }) => {
    var _a, _b, _c, _d;
    return ({
        background: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.navigation.background,
        color: (_b = theme.account) === null || _b === void 0 ? void 0 : _b.navigation.text,
        borderRadius: 0,
        padding: theme.spacing(1, 2),
        textTransform: 'none',
        width: '100%',
        border: '2px solid',
        '&:hover': {
            color: (_c = theme.account) === null || _c === void 0 ? void 0 : _c.navigation.background,
            background: (_d = theme.account) === null || _d === void 0 ? void 0 : _d.navigation.text,
        },
        '&:focus-visible': {
            // Enhance keyboard focus visibility
            outline: `3px solid ${theme.palette.primary.main}`,
            outlineOffset: '2px',
        },
    });
});
export default Button;
